import { render, staticRenderFns } from "./DropdownGroup.vue?vue&type=template&id=08372a09"
import script from "./DropdownGroup.vue?vue&type=script&lang=js"
export * from "./DropdownGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports